// extracted by mini-css-extract-plugin
module.exports = {"course-units-container":"course-units_course-units-container__SnU6i","course-unit-container":"course-units_course-unit-container___V3gu"};